import { useMemo } from 'react';
import { SquarePenIcon, TrashIcon } from 'lucide-react';
import classnames from 'classnames';

import { Plan, PlanFrequency } from '@app-types/service.type';
import NumberUtil, { Currency } from '@utils/number.util';

import styles from './plan-item.module.scss';

type Props = {
    plan: Plan;
    frequency: PlanFrequency;
};

const PlanItem = ({ plan, frequency }: Props) => {
    const price = useMemo(() => {
        const price = '$0.00';
        if (!plan.prices || plan.prices.length === 0) return price;

        const firstPrice = plan.prices[0];
        return NumberUtil.formatCurrency(
            firstPrice.price,
            firstPrice.currency as Currency
        );
    }, [plan.prices]);

    const billingType = useMemo(() => {
        return plan.type === 'one_time' ? ' Pago único' : ' Pago recurrente';
    }, [plan.id]);

    return (
        <div className={styles.plan}>
            <div className={styles.leftSide}>
                <div className={styles.planName}>
                    <span className={styles.title}>{plan.description}</span>
                    <span className={styles.tag}>{billingType}</span>
                    {plan.deletedAt && (
                        <span className={classnames(styles.tag, styles.red)}>
                            Eliminado
                        </span>
                    )}
                </div>
            </div>
            <div className={styles.rightSide}>
                <div className={styles.priceContainer}>
                    <span className={styles.price}>{price}</span>
                    <span className={styles.recurrence}>/{frequency.name}</span>
                </div>
                <div className={styles.actions}>
                    <div
                        className={classnames({
                            [styles.action]: true,
                            [styles.disabled]: !!plan.deletedAt,
                        })}
                        data-action="edit-plan"
                        data-id={plan.id}
                    >
                        <SquarePenIcon size={16} />
                    </div>
                    {!plan.deletedAt && (
                        <div
                            className={styles.action}
                            data-action="delete-plan"
                            data-id={plan.id}
                        >
                            <TrashIcon size={16} color="#fa6c6c" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export { PlanItem };
